<template>
  <div class="home-box hq-center">

    <div class="page">
      <aside class="aside card">
        <div class="card-title">团队成员</div>
        <div class="member-meta">团队组员，共12人，分别负责任务</div>
        <ul class="member-list">
          <li v-for="member in members" :key="member.name">
            <img :src="member.avatar" alt="">
            <div class="member-info">
              <div class="name">{{ member.name }}</div>
              <div class="role">{{ member.role }}</div>
            </div>
            <div class="status" :class="member.status === '在线' ? 'on' : 'off'">
              <span class="dot" />
              {{ member.status }}
            </div>
          </li>
        </ul>
      </aside>

      <main class="main">
        <div class="stats">
          <div class="stat-card" v-for="stat in stats" :key="stat.label">
            <img :src="stat.icon" alt="">
            <div>
              <div class="value">{{ stat.value }}</div>
              <div class="label">{{ stat.label }}</div>
            </div>
          </div>
        </div>

        <div class="panel-row">
          <div class="card info-card">
            <div class="info-header">
              <div class="title">员工详情</div>
              <div class="pill-group">
                <span class="pill active">分配任务</span>
                <span class="pill">绩效评估</span>
              </div>
            </div>
            <div class="info-body">
              <div class="user-summary">
                <img :src="focus.avatar" alt="">
                <div>
                  <div class="user-name">{{ focus.name }}</div>
                  <div class="user-role">{{ focus.role }}</div>
                  <div class="user-id">工号：{{ focus.id }}</div>
                </div>
              </div>

              <div class="info-grid">
                <div class="info-item">
                  <div class="label">入职时间</div>
                  <div class="value">{{ focus.entry }}</div>
                </div>
                <div class="info-item">
                  <div class="label">工作经验</div>
                  <div class="value">{{ focus.years }}</div>
                </div>
                <div class="info-item">
                  <div class="label">联系方式</div>
                  <div class="value">{{ focus.mail }}</div>
                </div>
                <div class="info-item">
                  <div class="label">当前状态</div>
                  <div class="value">在职</div>
                </div>
              </div>

              <div class="info-grid">
                <div class="info-item">
                  <div class="label">本月绩效</div>
                  <div class="value strong">{{ focus.score }}</div>
                </div>
                <div class="info-item">
                  <div class="label">团队排名</div>
                  <div class="value strong">{{ focus.rank }}</div>
                </div>
                <div class="info-item">
                  <div class="label">完成任务</div>
                  <div class="value strong">{{ focus.tasks }}</div>
                </div>
                <div class="info-item">
                  <div class="label">客户满意度</div>
                  <div class="value strong">{{ focus.satisfaction }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="card chart-card">
            <div class="card-title">团队绩效分析</div>
            <div class="chart-body">
              <div class="y-axis">
                <span v-for="n in 6" :key="n">{{ (n - 1) * 20 }}</span>
              </div>
              <div class="chart">
                <div class="bar-group" v-for="bar in chart" :key="bar.label">
                  <div class="bar tasks" :style="{ height: bar.tasks + '%' }" />
                  <div class="bar score" :style="{ height: bar.score + '%' }" />
                  <div class="bar-label">{{ bar.label }}</div>
                </div>
              </div>
            </div>
            <div class="legend">
              <div><span class="dot gold" />绩效分数</div>
              <div><span class="dot blue" />任务完成率</div>
            </div>
          </div>
        </div>

        <div class="panel-row">
          <div class="card tasks-card">
            <div class="card-title">任务分配</div>
            <div class="task" v-for="task in tasks" :key="task.title">
              <div class="task-head">
                <div>
                  <div class="task-title">{{ task.title }}</div>
                  <div class="task-meta">负责：{{ task.owner }}</div>
                </div>
                <div class="deadline">
                  截止: {{ task.deadline }}
                </div>
              </div>
              <div class="progress">
                <div class="progress-bar" :style="{ width: task.progress + '%' }" />
              </div>
              <div class="percent">{{ task.progress }}%</div>
            </div>
          </div>

          <div class="card evaluate-card">
            <div class="card-title">绩效评估</div>
            <div class="grade">
              <div class="label">评估标题</div>
              <div class="value">绩效评估</div>
            </div>
            <div class="grade">
              <div class="label">工作质量</div>
              <div class="stars">
                <span v-for="n in 5" :key="'a'+n" :class="{ on: n <= 5 }">●</span>
              </div>
            </div>
            <div class="grade">
              <div class="label">工作效率</div>
              <div class="stars">
                <span v-for="n in 5" :key="'b'+n" :class="{ on: n <= 4 }">●</span>
              </div>
            </div>
            <div class="grade">
              <div class="label">团队协作</div>
              <div class="stars">
                <span v-for="n in 5" :key="'c'+n" :class="{ on: n <= 3 }">●</span>
              </div>
            </div>
            <div class="grade">
              <div class="label">创新能力</div>
              <div class="stars">
                <span v-for="n in 5" :key="'d'+n" :class="{ on: n <= 2 }">●</span>
              </div>
            </div>
            <div class="comment">
              <div class="label">评语与反馈</div>
              <textarea placeholder="请输入评价意见..." />
            </div>
            <div class="total">
              总体评分 <span class="score">4</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import avator from '@/assets/images/avator.png'
import homeBg from '@/assets/images/home-bg.png'

export default {
  name: 'HeadquartersCenter',
  data () {
    return {
      logo: homeBg,
      navs: ['首页', '个人中心', '主管中心', 'AI助手'],
      user: {
        name: '张经理',
        avatar: avator
      },
      members: [
        { name: '黎明', role: '高级工程师', status: '在线', avatar: avator },
        { name: '王小桐', role: '高级工程师', status: '在线', avatar: avator },
        { name: '刘芳', role: '高级工程师', status: '忙碌', avatar: avator },
        { name: '陈浩', role: '后端工程师', status: '在线', avatar: avator },
        { name: '孙雨', role: '后端工程师', status: '忙碌', avatar: avator },
        { name: '王小红', role: '前端工程师', status: '在线', avatar: avator }
      ],
      stats: [
        { label: '团队总人数', value: 12, icon: homeBg },
        { label: '本月优秀员工', value: 3, icon: homeBg },
        { label: '待处理任务', value: 8, icon: homeBg },
        { label: '紧急事件', value: 3, icon: homeBg }
      ],
      focus: {
        name: '黎明',
        role: '高级工程师',
        id: '2024002',
        entry: '2021年6月',
        years: '5年',
        mail: 'li.ming@company.com',
        score: '92分',
        rank: '第2名',
        tasks: '15/18项',
        satisfaction: '96%',
        avatar: avator
      },
      chart: [
        { label: '黎明', score: 88, tasks: 80 },
        { label: '王小桐', score: 76, tasks: 70 },
        { label: '刘芳', score: 82, tasks: 75 },
        { label: '陈浩', score: 95, tasks: 90 },
        { label: '孙雨', score: 90, tasks: 85 },
        { label: '王小红', score: 80, tasks: 70 }
      ],
      tasks: [
        { title: '系统架构优化', owner: '黎明', deadline: '11月16日', progress: 60 },
        { title: '前端组件重构', owner: '王小红', deadline: '11月20日', progress: 40 },
        { title: '数据底座优化', owner: '刘芳', deadline: '11月25日', progress: 30 }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
@import url('./index.modules.less');
@bg: #f7f8fb;
@card: #fff;
@gold: #c99a2a;
@gold-2: #f3cb8e;
@blue: #4a7bde;

.hq-center {
  background: @bg;
  min-height: 100vh;
  color: #333;
  font-family: 'PingFang SC', sans-serif;
}

.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  background: linear-gradient(90deg, #6b481c 0%, #c18f2d 100%);
  color: #fff;

  .nav-brand {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;

    img {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      object-fit: cover;
    }
  }

  .nav-links {
    display: flex;
    list-style: none;
    gap: 24px;
    padding: 0;
    margin: 0;

    li {
      padding: 6px 12px;
      border-radius: 16px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.8);

      &.active {
        background: #e8b55b;
        color: #6b481c;
      }
    }
  }

  .nav-actions {
    display: flex;
    align-items: center;
    gap: 16px;

    .search {
      display: flex;
      align-items: center;
      background: rgba(255, 255, 255, 0.15);
      padding: 6px 10px;
      border-radius: 18px;

      input {
        border: none;
        background: transparent;
        outline: none;
        color: #fff;
        padding-left: 6px;
      }
    }

    .user {
      display: flex;
      align-items: center;
      gap: 8px;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
  }
}

.page {
  display: flex;
  padding: 16px;
  gap: 16px;
}

.card {
  background: @card;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
}

.aside {
  width: 260px;
  padding: 16px;
  .card-title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 4px;
  }
  .member-meta {
    font-size: 12px;
    color: #999;
    margin-bottom: 12px;
  }
  .member-list {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      display: flex;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #f0f0f0;
      &:last-child {
        border-bottom: none;
      }
      img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .member-info {
        flex: 1;
        .name {
          font-weight: 600;
        }
        .role {
          font-size: 12px;
          color: #999;
        }
      }
      .status {
        font-size: 12px;
        display: flex;
        align-items: center;
        gap: 4px;
        color: #999;
        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #999;
        }
        &.on {
          color: #2fc45b;
          .dot { background: #2fc45b; }
        }
        &.off {
          color: #ff9d28;
          .dot { background: #ff9d28; }
        }
      }
    }
  }
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;

  .stat-card {
    background: @card;
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);

    img {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      object-fit: cover;
    }
    .value {
      font-size: 20px;
      font-weight: 700;
    }
    .label {
      font-size: 12px;
      color: #999;
    }
  }
}

.panel-row {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 12px;
}

.info-card {
  padding: 16px;
  .info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .title {
      font-weight: 600;
      font-size: 16px;
    }
    .pill-group {
      background: #f7f1e7;
      border-radius: 20px;
      display: inline-flex;
      padding: 4px;
      gap: 6px;
      .pill {
        padding: 6px 12px;
        border-radius: 14px;
        cursor: pointer;
        color: #b08a37;
        &.active {
          background: linear-gradient(90deg, #f6d9a3 0%, #e9b562 100%);
          color: #6b481c;
          box-shadow: 0 2px 8px rgba(255, 196, 98, 0.4);
        }
      }
    }
  }
  .info-body {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .user-summary {
    display: flex;
    gap: 12px;
    align-items: center;
    img {
      width: 64px;
      height: 64px;
      border-radius: 12px;
      object-fit: cover;
    }
    .user-name {
      font-size: 16px;
      font-weight: 700;
    }
    .user-role {
      color: #c58b2c;
      font-size: 12px;
    }
    .user-id {
      font-size: 12px;
      color: #999;
    }
  }
  .info-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    .info-item {
      background: #f9f5ee;
      border-radius: 8px;
      padding: 10px;
      .label {
        font-size: 12px;
        color: #9c7a2c;
        margin-bottom: 6px;
      }
      .value {
        font-weight: 600;
        color: #5c4b32;
      }
      .strong {
        font-size: 18px;
      }
    }
  }
}

.chart-card {
  padding: 16px;
  .card-title {
    font-weight: 600;
    margin-bottom: 10px;
  }
  .chart-body {
    display: flex;
    gap: 12px;
    align-items: flex-end;
    height: 200px;
    .y-axis {
      display: flex;
      flex-direction: column-reverse;
      gap: 14px;
      color: #bbb;
      font-size: 12px;
    }
    .chart {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 10px;
      align-items: end;
      .bar-group {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        .bar {
          width: 14px;
          border-radius: 6px 6px 0 0;
          &.tasks { background: linear-gradient(180deg, @gold 0%, @gold-2 100%); }
          &.score { background: linear-gradient(180deg, @blue 0%, lighten(@blue, 10%) 100%); }
        }
        .bar-label {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }
  .legend {
    display: flex;
    gap: 20px;
    margin-top: 8px;
    color: #666;
    font-size: 12px;
    .dot {
      width: 10px;
      height: 10px;
      display: inline-block;
      border-radius: 50%;
      margin-right: 6px;
    }
    .gold { background: @gold; }
    .blue { background: @blue; }
  }
}

.tasks-card {
  padding: 16px;
  .card-title {
    font-weight: 600;
    margin-bottom: 12px;
  }
  .task {
    padding: 10px 0;
    border-bottom: 1px solid #f3f3f3;
    &:last-child {
      border-bottom: none;
    }
    .task-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .task-title { font-weight: 600; }
      .task-meta { font-size: 12px; color: #999; }
      .deadline {
        background: #fdf3e3;
        color: #b7781f;
        padding: 4px 10px;
        border-radius: 10px;
        font-size: 12px;
      }
    }
    .progress {
      margin: 8px 0;
      background: #f1f1f1;
      border-radius: 6px;
      height: 10px;
      .progress-bar {
        height: 10px;
        border-radius: 6px;
        background: linear-gradient(90deg, #ffd792 0%, #f2b44d 100%);
      }
    }
    .percent {
      font-size: 12px;
      color: #999;
      text-align: right;
    }
  }
}

.evaluate-card {
  padding: 16px;
  .card-title {
    font-weight: 600;
    margin-bottom: 10px;
  }
  .grade {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px 0;
    .label { color: #666; }
    .value { font-weight: 600; }
    .stars {
      display: flex;
      gap: 6px;
      span {
        color: #ddd;
        font-size: 12px;
        &.on { color: @gold; }
      }
    }
  }
  .comment {
    margin-top: 12px;
    .label { color: #666; margin-bottom: 6px; }
    textarea {
      width: 100%;
      height: 70px;
      border: 1px solid #eee;
      border-radius: 8px;
      padding: 8px;
      resize: none;
      outline: none;
      background: #fffaf0;
    }
  }
  .total {
    margin-top: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
    .score {
      width: 28px;
      height: 28px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: @gold;
      color: #fff;
      border-radius: 50%;
    }
  }
}
</style>